module.exports = __webpack_public_path__ + "img/menu-icon-1-2.e0aca1cb.svg";